import { render, staticRenderFns } from "./MediaInfo.vue?vue&type=template&id=4374db54&scoped=true&"
import script from "./MediaInfo.vue?vue&type=script&lang=js&"
export * from "./MediaInfo.vue?vue&type=script&lang=js&"
import style0 from "./MediaInfo.vue?vue&type=style&index=0&id=4374db54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4374db54",
  null
  
)

export default component.exports